import app, { Component } from 'apprun';
import { phones as phoneApi, } from '../api';
import { isValid, getLookupValueById, showSaveStatusMessage } from '../utils';
import { lookup_en } from '../utils';

export default class CommonPropertyComponent extends Component {
  state = { addPhoneTypes: [] };
  view = (state) => {
    if (!state.item) {return;}
    return (
      <div class="list-group">
        <form id="phoneEditForm">
          <table>
            <thead>
              <th>Phone Type</th>
              <th>Number</th>
              <th>Show</th>
            </thead>
            {state.phones
              ? state.phones.map(p => (
                <tr>
                  <td>
                    <span>{getLookupValueById(lookup_en.PhoneTypeCt, p.phoneTypeCt)}</span>
                  </td>
                  <td>
                    <input
                      id={'inpPhone' + p.phoneTypeCt}
                      size="10"
                      value={p.phoneNumber}
                      oninput={(e) => {
                        p.phoneNumber = e.target.value;
                      }}
                      data-validate="Phone"
                    />
                    <div id={'inpPhone' + p.phoneTypeCt + 'ErrMsg'} class="text-danger"></div>
                  </td>
                  <td>
                      &nbsp;
                    <input
                      name="displayInd"
                      type="checkbox"
                      checked={p.displayInd ? 'checked' : null}
                      onchange={(e) => {
                        p.displayInd = e.target.checked;
                      }}
                    />
                  </td>
                  <td>
                    <a onclick={() => this.run('del', p)}>✂</a>
                  </td>
                </tr>
              ))
              : ''}
            <tr>
              <td>
                <br />
                add &nbsp;
                <select name="phoneTypeCt" oninput={e => this.run('add', e.target.value, e.target.selectedIndex)}>
                  <option value=" ">[Select]</option>
                  {state.addPhoneTypes.map(r => (
                    <option value={r.id}>{r.value}</option>
                  ))}
                </select>
              </td>
            </tr>
          </table>
        </form>
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={e => this.run('save', e)}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => this.run('cancel')}>
            cancel
          </a>
        </div>
      </div>
    );
  };

  update = {
    save: async (state) => {
      if (!isValid('phoneEditForm')) {return;}
      try{
        const result = await phoneApi.postPhones(state.objectTypeId, state.phoneId, state.phones);
        showSaveStatusMessage('phone');
        if (result) {state.caller.run(state.save, state.item, state.panelId);}
      }catch{showSaveStatusMessage();}
    },

    del: (state, p) => {
      //console.log('In delPhone...');
      state.phones.splice(state.phones.indexOf(p), 1);
      state.addPhoneTypes.push({ id: p.phoneTypeCt, value: getLookupValueById(lookup_en.PhoneTypeCt, p.phoneTypeCt) });
      return state;
    },

    add: (state, phoneType, selectedIndex) => {
      //console.log('In addPhone...');
      if (phoneType.trim()) {
        state.phones.push({
          objectID: state.companyId,
          objectTypeID: 1,
          phoneTypeCt: phoneType,
          phoneNumber: '',
          displayInd: true
        });
      }
      state.addPhoneTypes.splice(selectedIndex - 1, 1);
      return state;
    },

    cancel: (state) => {
      state.caller.run(state.cancel, state.panelId);
    },

    refresh: async (state, newState) => {

      state = newState;
      const phones = await phoneApi.getPhones(state.objectTypeId, state.phoneId);
      const addPhoneTypes = lookup_en.PhoneTypeCt.filter(p => phones.findIndex(r => r.phoneTypeCt === p.id) < 0);

      return { ...state, phones, addPhoneTypes };
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
